export enum QuestionType {
  SHORT_TEXT = 'ShortAnswer',
  LONG_TEXT = 'LongAnswer',
  RADIO = 'RadioButton',
  CHECKBOX = 'Checkbox',
  YES_NO = 'YesNo',
  DATE = 'Date',
  INTEGER = 'NumericInteger',
  DECIMAL = 'NumericDecimal',
  CURRENCY = 'Currency',
  TABLE = 'Table',
  PHOTO = 'Photo',
  FILE = 'File',
}

export interface DisplayRule {
  condition: string;
  value: string;
  action: string;
}

export interface Question {
  id: string;
  title: string;
  answerType: QuestionType;
  order: number;
  isRequired: boolean;
  showInSimplifiedReport: boolean;
  hasHint: boolean;
  hintText?: string;
  hasDisplayRule: boolean;
  displayRule?: DisplayRule;
  options?: string[];
  maxCharacters?: number;
  decimalPlaces?: number;
  maxPhotos?: number;
  allowGallery?: boolean;
  maxFiles?: number;
  allowedFileTypes?: ('image' | 'pdf')[];
  columns?: string[];
  tags?: string[];
  template?: string;
  description?: string;
}
